
<div class="modal" style="display:block !important">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title">IT Tooling Site</h2>
                <div class="btn-close" [mat-dialog-close]="true"></div>
            </div>
            <div class="modal-body">
                <p>
                    This site has approved tools loaded from each technical discipline
                    in IT.
                </p>
                <p>
                    You can search for your tool by persona, life cycle or free form
                    text.
                </p>
                <p><strong>Accessing each tool might be a bit different:</strong></p>
                <ul>
                    <li>
                        Some tools are running live and you can launch them directly
                        from here.
                    </li>
                    <li>
                        Other tools, the link will take you to an approved download site
                        or the company portal to install.
                    </li>
                    <li>
                        Still others might require approval first and the link will take
                        you directly to the request site to request access to the tool.
                    </li>
                    <li>
                        The final one would be if that tool needs to be provisioned
                        using the DevOps pipeline like Azure Data Factory, in that case
                        the launch button will take you to the ansible role you will use
                        to provision that tool.
                    </li>
                </ul>
                <p>
                    The goal of this site is to help you find the tool that you need and
                    to take you to where you can get that tool and begin using it.
                </p>
                <div
                    class="contact-info mt-3 p-3"
                    style="
                        background-color: #f8f9fa;
                        border-left: 4px solid var(--medium-blue);
                    "
                >
                    <p class="mb-0">
                        <strong>Don't find a tool that should be included here?</strong>
                    </p>
                    <p class="mb-0">
                        Please reach out to <strong>Kurt Charney</strong> -
                        <a href="mailto:kcharney@chevron.com">Send Email</a>
                    </p>
                </div>
            </div>
            <div class="modal-footer">
                <button class="secondary small" [mat-dialog-close]="true">
                    Got it!
                </button>
            </div>
        </div>
    </div>
</div>
